import axios from "axios";
import axiosInterceptor from './AxiosInterceptor';
import { makeSecureAPICall } from "./SignatureHelperFn";

// export const BaseUrl = ENVIRONMENTS[SELECTED_ENVIRONMENT].baseurl || "";
export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const idmUrl = process.env.REACT_APP_IDM_URL;

axiosInterceptor();

// Get Responses Category API
export const getResponsesCategory = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-category-data`, payload);
};

// Get Questions by Category API
export const getQuestionsByCategory = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-category-ques-data`, payload);
};

// Add Multiple Cards API
export const addMultipleCards = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/add-multiple-cards`, payload);
};

// Check Async Status API
export const checkAsyncStatus = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/check-async-status`, payload);
};

// Download Open Text Responses API
export const downloadOpenTextResponses = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/download-open-responses`, payload);
};

// Set Pin/Unpin Questions API
export const setPinUnpinQuestions = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/explore-pin-question`, payload);
};

// Get Response Details API
export const getResponseDetails = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-response-details`, payload);
};

// Get Response Reasons API
export const getResponseReasons = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-response-reasons`, payload);
};

// Get Response Reasons Dropdown API
export const getResponseReasonsDropdown = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-response-details-dropdown`, payload);
};